class ShopifyVariantQuantitySelector {
  constructor() {
    this.quantityInput = null;
    this.variantComponent = null;
    this.currentQuantity = 1;
    this.isProcessing = false;
    this.isUpdatingFromVariant = false; // Nueva bandera para evitar loops
    this.quantityRanges = [];
    this.subtotalElement = null;
    this.priceElement = null;
    this.retryCount = 0;
    this.maxRetries = 10;
    
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    setTimeout(() => {
      this.findElements();
      this.extractQuantityRanges();
      this.createSubtotalElement();
      this.bindEvents();
      this.bindManualVariantSelection(); // Nuevo: escuchar clicks manuales en variantes
      this.initializeSubtotal();
      console.log('✅ Selector inicializado correctamente');
    }, 500);
  }

  findElements() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[id*="quantity"]',
      '.quantity input',
      '[data-quantity-input]'
    ];

    for (const selector of quantitySelectors) {
      this.quantityInput = document.querySelector(selector);
      if (this.quantityInput) break;
    }

    this.variantComponent = document.querySelector('variant-selects, variant-radios');

    const priceSelectors = [
      '.price__regular .price-item--regular',
      '.price-item--regular',
      '[data-price]',
      '.price .price-item',
      '#price-' + this.variantComponent?.dataset?.section + ' .price-item--regular'
    ];

    for (const selector of priceSelectors) {
      this.priceElement = document.querySelector(selector);
      if (this.priceElement) break;
    }

    if (!this.quantityInput) {
      console.warn('❌ No se encontró input de cantidad');
      return;
    }

    if (!this.variantComponent) {
      console.warn('❌ No se encontró componente de variantes');
      return;
    }

    console.log('✅ Input cantidad:', this.quantityInput);
    console.log('✅ Componente variantes:', this.variantComponent);
    console.log('✅ Elemento precio:', this.priceElement);
  }

  /**
   * NUEVO: Escucha cuando el usuario hace clic manualmente en una variante
   * y ajusta la cantidad al mínimo del rango
   */
  bindManualVariantSelection() {
    if (!this.variantComponent) return;

    const radios = this.variantComponent.querySelectorAll('input[type="radio"]');
    const selects = this.variantComponent.querySelectorAll('select');

    // Para radio buttons
    radios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        // Solo actuar si no es un cambio programático
        if (!this.isProcessing) {
          this.handleManualVariantChange(radio.value);
        }
      });
    });

    // Para select dropdowns
    selects.forEach(select => {
      select.addEventListener('change', (e) => {
        if (!this.isProcessing) {
          this.handleManualVariantChange(select.value);
        }
      });
    });

    console.log('✅ Listeners de selección manual configurados');
  }

  /**
   * Maneja cuando el usuario selecciona manualmente una variante
   */
  handleManualVariantChange(selectedValue) {
    // Buscar el rango correspondiente a esta opción
    const range = this.quantityRanges.find(r => r.displayValue === selectedValue);
    
    if (!range) {
      console.log('ℹ️ No se encontró rango para la opción:', selectedValue);
      return;
    }

    const currentQuantity = parseInt(this.quantityInput.value) || 1;
    
    // Verificar si la cantidad actual está fuera del rango
    if (currentQuantity < range.min || currentQuantity > range.max) {
      console.log(`🔄 Ajustando cantidad de ${currentQuantity} a ${range.min} (mínimo de "${selectedValue}")`);
      
      this.isUpdatingFromVariant = true; // Activar bandera para evitar loop
      
      // Actualizar el input de cantidad
      this.quantityInput.value = range.min;
      this.currentQuantity = range.min;
      
      // Disparar evento change para que otros componentes se enteren
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Actualizar subtotal
      setTimeout(() => {
        this.updateSubtotal();
        this.isUpdatingFromVariant = false; // Desactivar bandera
      }, 100);
    } else {
      console.log(`✅ Cantidad ${currentQuantity} está dentro del rango "${selectedValue}"`);
    }
  }

  initializeSubtotal() {
    const tryUpdate = () => {
      this.retryCount++;
      
      const success = this.updateSubtotal();
      
      if (!success && this.retryCount < this.maxRetries) {
        console.log(`🔄 Reintentando cálculo de subtotal (${this.retryCount}/${this.maxRetries})...`);
        setTimeout(tryUpdate, 300);
      } else if (success) {
        console.log('✅ Subtotal inicial calculado correctamente');
        this.observePriceChanges();
      } else {
        console.warn('⚠️ No se pudo calcular el subtotal después de varios intentos');
      }
    };

    tryUpdate();
  }

  observePriceChanges() {
    if (!this.priceElement) return;

    const observer = new MutationObserver(() => {
      console.log('💰 Precio cambió, actualizando subtotal...');
      this.updateSubtotal();
    });

    observer.observe(this.priceElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  createSubtotalElement() {
    let existingSubtotal = document.getElementById('product-subtotal');
    if (existingSubtotal) {
      this.subtotalElement = existingSubtotal.querySelector('#subtotal-amount');
      return;
    }

    const subtotalContainer = document.createElement('div');
    subtotalContainer.id = 'product-subtotal';
    subtotalContainer.className = 'product-subtotal';
    subtotalContainer.style.cssText = `
      margin-top: 1rem;
      padding: 1rem;
      background: #f7f7f7;
      border-radius: 4px;
      font-size: 1.2rem;
      font-weight: 600;
    `;

    subtotalContainer.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="color: #333;">Subtotal:</span>
        <span id="subtotal-amount" style="color: #000; font-size: 1.4rem;">Calculando...</span>
      </div>
      <div style="font-size: 0.85rem; color: #666; margin-top: 0.5rem;">
        <span id="subtotal-calculation"></span>
      </div>
    `;

    const priceContainer = document.querySelector(
      '.price, .product__info-container .price, #price-' + this.variantComponent?.dataset?.section
    );
    
    if (priceContainer) {
      priceContainer.parentNode.insertBefore(subtotalContainer, priceContainer.nextSibling);
    } else {
      const quantityContainer = this.quantityInput?.closest('.product-form__input, .quantity-selector, quantity-input');
      if (quantityContainer) {
        quantityContainer.parentNode.insertBefore(subtotalContainer, quantityContainer.nextSibling);
      }
    }

    this.subtotalElement = document.getElementById('subtotal-amount');
    console.log('✅ Elemento subtotal creado');
  }

  extractQuantityRanges() {
    if (!this.variantComponent) return;

    const allVariants = this.variantComponent.getVariantData();
    const radios = this.variantComponent.querySelectorAll('input[type="radio"]');
    const selects = this.variantComponent.querySelectorAll('select');
    
    if (radios.length > 0) {
      radios.forEach(radio => {
        const value = radio.value;
        this.parseAndAddRange(value, allVariants);
      });
    } else if (selects.length > 0) {
      selects.forEach(select => {
        Array.from(select.options).forEach(option => {
          const value = option.value;
          this.parseAndAddRange(value, allVariants);
        });
      });
    }

    this.quantityRanges.sort((a, b) => a.min - b.min);
    console.log('📊 Rangos de cantidad configurados:', this.quantityRanges);
  }

  parseAndAddRange(value, allVariants) {
    let min, max, isOpenEnded = false;

    const openEndedMatch = value.match(/(\d+)\+/);
    if (openEndedMatch) {
      min = parseInt(openEndedMatch[1], 10);
      max = Infinity;
      isOpenEnded = true;
    } else {
      const rangeMatch = value.match(/(\d+)\s*-\s*(\d+)/);
      if (rangeMatch) {
        min = parseInt(rangeMatch[1], 10);
        max = parseInt(rangeMatch[2], 10);
      } else {
        return;
      }
    }

    const variant = this.findVariantByOption(allVariants, value);
    
    if (variant) {
      this.quantityRanges.push({
        min: min,
        max: max,
        isOpenEnded: isOpenEnded,
        variantId: variant.id,
        options: variant.options,
        displayValue: value
      });
    }
  }

  findVariantByOption(variants, optionValue) {
    return variants.find(variant => 
      variant.options.some(opt => opt === optionValue)
    );
  }

  bindEvents() {
    if (!this.quantityInput) return;

    const events = ['input', 'change'];
    events.forEach(eventType => {
      this.quantityInput.addEventListener(eventType, () => {
        // No procesar si el cambio viene de una actualización por variante
        if (this.isUpdatingFromVariant) return;
        
        clearTimeout(this.quantityTimeout);
        this.quantityTimeout = setTimeout(() => {
          this.handleQuantityChange();
        }, 150);
      });
    });

    this.bindQuantityButtons();
    this.bindVariantChanges();
  }

  bindQuantityButtons() {
    const buttons = document.querySelectorAll('button[name="plus"], button[name="minus"]');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.handleQuantityChange();
          this.updateSubtotal();
        }, 100);
      });
    });
  }

  bindVariantChanges() {
    if (!this.variantComponent) return;

    this.variantComponent.addEventListener('change', () => {
      setTimeout(() => {
        this.updateSubtotal();
      }, 100);
    });
  }

  handleQuantityChange() {
    if (this.isProcessing) return;
    
    const quantity = parseInt(this.quantityInput.value) || 1;
    
    if (quantity === this.currentQuantity) {
      this.updateSubtotal();
      return;
    }
    
    console.log(`🔄 Cantidad cambiada: ${this.currentQuantity} → ${quantity}`);
    this.currentQuantity = quantity;
    
    const targetRange = this.getVariantForQuantity(quantity);
    
    if (targetRange) {
      this.selectVariantByOptions(targetRange.options);
    } else {
      console.log('⚠️ No se encontró variante para cantidad:', quantity);
    }
    
    setTimeout(() => {
      this.updateSubtotal();
    }, 300);
  }

  getVariantForQuantity(quantity) {
    const range = this.quantityRanges.find(range => {
      return quantity >= range.min && quantity <= range.max;
    });
    
    if (range) {
      const rangeText = range.isOpenEnded 
        ? `${range.min}+` 
        : `${range.min}-${range.max}`;
      console.log(`✅ Rango encontrado para cantidad ${quantity}: ${rangeText}`, range);
    }
    
    return range || null;
  }

  updateSubtotal() {
    if (!this.subtotalElement) return false;

    const quantity = parseInt(this.quantityInput?.value) || 1;
    let priceInCents = null;
    let currentVariant = this.variantComponent?.currentVariant;

    if (currentVariant && currentVariant.price) {
      priceInCents = currentVariant.price;
      console.log('💰 Precio obtenido de currentVariant:', priceInCents);
    } 
    else {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const allVariants = this.variantComponent?.getVariantData();
        currentVariant = allVariants?.find(v => v.id == variantInput.value);
        if (currentVariant) {
          priceInCents = currentVariant.price;
          console.log('💰 Precio obtenido de input hidden:', priceInCents);
        }
      }
    }

    if (!priceInCents && this.priceElement) {
      const priceText = this.priceElement.textContent.trim();
      const priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        const priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
        priceInCents = Math.round(priceValue * 100);
        console.log('💰 Precio parseado del DOM:', priceInCents);
      }
    }

    if (!priceInCents) {
      console.warn('⚠️ No se pudo obtener el precio');
      this.subtotalElement.textContent = 'Calculando...';
      return false;
    }

    const pricePerUnit = priceInCents / 100;
    const subtotal = pricePerUnit * quantity;

    const currency = this.detectCurrency();
    const formattedPrice = this.formatMoney(priceInCents, currency);
    const formattedSubtotal = this.formatMoney(subtotal * 100, currency);

    this.subtotalElement.textContent = formattedSubtotal;
    
    const calculationElement = document.getElementById('subtotal-calculation');
    if (calculationElement) {
      calculationElement.textContent = `${quantity} × ${formattedPrice} por unidad`;
    }

    console.log(`💰 Subtotal actualizado: ${quantity} × ${formattedPrice} = ${formattedSubtotal}`);
    return true;
  }

  detectCurrency() {
    if (window.Shopify?.currency?.active) {
      return window.Shopify.currency.active;
    }

    if (this.priceElement) {
      const priceText = this.priceElement.textContent;
      if (priceText.includes('$')) return 'USD';
      if (priceText.includes('€')) return 'EUR';
      if (priceText.includes('£')) return 'GBP';
      if (priceText.includes('COP')) return 'COP';
    }

    return 'USD';
  }

  formatMoney(cents, currency = 'USD') {
    const amount = cents / 100;

    const configs = {
      'USD': { symbol: '$', decimals: 2, position: 'before' },
      'EUR': { symbol: '€', decimals: 2, position: 'after' },
      'GBP': { symbol: '£', decimals: 2, position: 'before' },
      'COP': { symbol: '$', decimals: 0, position: 'before' },
      'MXN': { symbol: '$', decimals: 2, position: 'before' },
    };

    const config = configs[currency] || configs['USD'];
    
    const formattedAmount = amount.toLocaleString('en-US', {
      minimumFractionDigits: config.decimals,
      maximumFractionDigits: config.decimals
    });

    return config.position === 'before' 
      ? `${config.symbol}${formattedAmount}`
      : `${formattedAmount}${config.symbol}`;
  }

  selectVariantByOptions(options) {
    this.isProcessing = true;
    
    try {
      const fieldsets = this.variantComponent.querySelectorAll('fieldset');
      const selects = this.variantComponent.querySelectorAll('select');
      
      if (fieldsets.length > 0) {
        fieldsets.forEach((fieldset, index) => {
          if (options[index]) {
            const targetRadio = fieldset.querySelector(`input[value="${options[index]}"]`);
            if (targetRadio && !targetRadio.checked) {
              console.log(`🎯 Seleccionando opción ${index + 1}: ${options[index]}`);
              targetRadio.click();
            }
          }
        });
      } else if (selects.length > 0) {
        selects.forEach((select, index) => {
          if (options[index]) {
            if (select.value !== options[index]) {
              console.log(`🎯 Seleccionando opción ${index + 1}: ${options[index]}`);
              select.value = options[index];
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      }

      setTimeout(() => {
        const currentVariant = this.variantComponent.currentVariant;
        if (currentVariant) {
          console.log(`✅ Variante seleccionada: ID ${currentVariant.id}`, currentVariant);
        } else {
          console.warn('❌ No se pudo seleccionar la variante');
        }
      }, 300);

    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    }
  }

  selectVariantById(variantId) {
    const allVariants = this.variantComponent.getVariantData();
    const targetVariant = allVariants.find(v => v.id === variantId);
    
    if (targetVariant) {
      this.selectVariantByOptions(targetVariant.options);
    }
  }

  forceSelectVariant(variantId) {
    console.log(`🔧 Forzando selección de variante: ${variantId}`);
    this.selectVariantById(variantId);
  }

  testQuantity(quantity) {
    console.log(`🧪 Probando con cantidad: ${quantity}`);
    this.quantityInput.value = quantity;
    this.handleQuantityChange();
  }
}

// Helper para debugging
function debugVariants() {
  console.log('🔍 === DEBUG DE VARIANTES ===');
  
  const component = document.querySelector('variant-selects, variant-radios');
  if (!component) {
    console.log('❌ No se encontró componente de variantes');
    return;
  }
  
  const allVariants = component.getVariantData();
  console.log('📦 Total de variantes:', allVariants.length);
  
  allVariants.forEach((variant, index) => {
    const price = (variant.price / 100).toFixed(2);
    console.log(`\n${index + 1}. ID: ${variant.id}`);
    console.log(`   Opciones: ${variant.options.join(' / ')}`);
    console.log(`   Disponible: ${variant.available}`);
    console.log(`   Precio: $${price}`);
  });
  
  console.log('\n🎯 Variante actual:', component.currentVariant);
  
  if (window.shopifyVariantSelector && window.shopifyVariantSelector.quantityRanges.length > 0) {
    console.log('\n📊 Rangos de cantidad:');
    window.shopifyVariantSelector.quantityRanges.forEach((range, i) => {
      const rangeText = range.isOpenEnded 
        ? `${range.min}+` 
        : `${range.min}-${range.max}`;
      console.log(`${i + 1}. ${rangeText} → Variante ID: ${range.variantId}`);
    });
  }
  
  console.log('=========================');
}

function testQuantity(quantity) {
  if (window.shopifyVariantSelector) {
    window.shopifyVariantSelector.testQuantity(quantity);
  } else {
    console.warn('El selector no está inicializado');
  }
}

// Inicialización
(function() {
  const initSelector = () => {
    console.log('🚀 Inicializando Shopify Variant Quantity Selector...');
    
    window.shopifyVariantSelector = new ShopifyVariantQuantitySelector();
    window.debugVariants = debugVariants;
    window.testQuantity = testQuantity;
    
    console.log('💡 Funciones de debug disponibles:');
    console.log('- debugVariants() - Muestra info de todas las variantes y rangos');
    console.log('- testQuantity(N) - Prueba con una cantidad específica');
    console.log('- shopifyVariantSelector.forceSelectVariant(ID) - Selección manual');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initSelector, 1000);
    });
  } else {
    setTimeout(initSelector, 1000);
  }
})();

/*Cambios principales:

1. **bindManualVariantSelection()**: Nuevo método que escucha clicks manuales en las variantes
2. **handleManualVariantChange()**: Ajusta la cantidad al mínimo del rango cuando se selecciona una variante manualmente
3. **isUpdatingFromVariant**: Bandera para evitar loops infinitos (variante → cantidad → variante)
4. **Verificación inteligente**: Solo actualiza la cantidad si está fuera del rango seleccionado

## Ejemplos de comportamiento:
Cantidad actual: 8
Usuario hace clic en variante "4 - 7"
→ Cantidad se ajusta a 4 ✅

Cantidad actual: 5
Usuario hace clic en variante "4 - 7"
→ Cantidad se mantiene en 5 (está dentro del rango) ✅

Cantidad actual: 3
Usuario hace clic en variante "8+"
→ Cantidad se ajusta a 8*/